<template>
  <div>
    <div class="py-10" v-if="get_loading">
      <p class="text-center"><i class="el-icon-loading"></i></p>
    </div>
    <div v-if="!get_loading">
      <div class="list-user-role-header">
        <div class="menu-header-check-all">
          <input type="checkbox" v-model="checkAll" @change="handleCheckAllChange" />
        </div>
        <div class="filter-section-custom">
          <el-input
            v-model="filters.username"
            placeholder="Cari username..."
            prefix-icon="el-icon-search"
            size="small"
            clearable
            style="width: 200px; margin-right: 10px;"
            @clear="handleFilterChange"
            @keyup.enter.native="handleFilterChange"
          >
          </el-input>
          <el-select
            v-model="filters.rolename"
            placeholder="Semua Role"
            size="small"
            clearable
            style="width: 200px; margin-right: 10px;"
          >
            <el-option label="Semua Role" value=""></el-option>
            <el-option
              v-for="role in availableRoles"
              :key="role.value"
              :label="role.label"
              :value="role.value"
            >
            </el-option>
          </el-select>
          <el-button 
            size="small" 
            type="primary" 
            icon="el-icon-search"
            @click="handleFilterChange"
          >
            Cari
          </el-button>
        </div>
        <div>
          <el-button size="mini" type="default" icon="el-icon-view" v-if="items.selected.length === 1" circle></el-button>
          <el-button size="mini" type="success" icon="el-icon-connection" v-if="items.selected.length === 1" circle @click="openManageRoleDialog"></el-button>
          <el-button size="mini" type="warning" icon="el-icon-key" v-if="items.selected.length === 1" circle @click="openResetPasswordDialog"></el-button>
          <el-button size="mini" type="primary" icon="el-icon-plus" v-if="items.selected.length === 0"  circle></el-button>
          <el-button size="mini" type="warning" icon="el-icon-edit" v-if="items.selected.length === 1" circle></el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" v-if="items.selected.length > 0" circle></el-button>
        </div>
      </div>
      <div class="list-user-role" v-for="(item, index) in get_user_role" :key="index">
        <div class="list-user-role-content">
          <div class="menu-zero">
            <input type="checkbox" :value="item" :label="item.id" v-model="items.selected" @change="handleCheckChange" />
          </div>
          <div class="menu-second">
            <p class="label-name leading-snug">{{ item.name }}</p>
            <p class="label-username leading-normal">{{ item.username == null ? 'Belum ada username' : item.username }}</p>
          </div>
          <div class="menu-third">
            <p class="label-date">{{ formatDate(item.lastLogin) }}</p> 
          </div>
        </div>
        <div class="menu-fourth">
          <el-tag v-for="(role, roleIndex) in item.roles" :key="role.id || role.roleCode || `role-${index}-${roleIndex}`" :type="getRoleTagType(role.roleName)" size="mini" class="mr-1">
            {{ role.roleName }}
          </el-tag>
        </div>
      </div>
      <div class="menu-footer" v-if="get_user_role_pagination">
        <el-pagination
          @current-change="handlePageChange"
          :current-page="get_user_role_pagination.pageNumber + 1"
          :page-size="get_user_role_pagination.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="get_user_role_pagination.totalElements">
        </el-pagination>
      </div>
    </div>

    <!-- Manage Role Dialog -->
    <el-dialog
      :visible.sync="manageRoleDialog"
      width="600px"
      :close-on-click-modal="false"
    >
      <div slot="title" class="bg-gradient-to-r from-green-600 to-teal-600 -m-5 mb-0 p-5 text-white rounded-t-lg">
        <div class="flex items-center space-x-3">
          <i class="el-icon-connection text-2xl"></i>
          <div>
            <h3 class="text-xl font-bold">Kelola Role User</h3>
            <p class="text-sm text-green-100">{{ selectedUser.name }} ({{ selectedUser.username }})</p>
          </div>
        </div>
      </div>

      <div class="py-4">
        <div class="bg-blue-50 p-4 rounded-lg mb-4">
          <label class="text-xs font-semibold text-blue-600 uppercase block mb-2">Informasi User</label>
          <div class="space-y-1">
            <p class="text-sm"><strong>Nama:</strong> {{ selectedUser.name }}</p>
            <p class="text-sm"><strong>Username:</strong> {{ selectedUser.username || '-' }}</p>
            <p class="text-sm"><strong>Last Login:</strong> {{ formatDate(selectedUser.lastLogin) }}</p>
          </div>
        </div>
        <!-- {{ selectedUser }} -->
        <div class="bg-purple-50 p-4 rounded-lg mb-4">
          <label class="text-xs font-semibold text-purple-600 uppercase block mb-3">Role Saat Ini</label>
          <div class="flex flex-wrap gap-2">
            <el-tag v-for="(role, index) in selectedUser.roles" :key="index" :type="getRoleTagType(role.roleName)" size="medium">
              {{ role.roleName }}
            </el-tag>
            <span v-if="!selectedUser.roles || selectedUser.roles.length === 0" class="text-gray-500 text-sm">Belum ada role</span>
          </div>
        </div>

        <div class="bg-green-50 p-4 rounded-lg">
          <label class="text-xs font-semibold text-green-600 uppercase block mb-3">Kelola Role</label>
          <!-- {{ availableRoles }} -->
          <!-- {{ selectedUser }} -->
          <div class="space-y-2">
            <div v-for="role in availableRoles" :key="role.roleName" class="bg-white p-3 rounded border hover:border-green-500 transition-colors flex items-center justify-between">
              <div class="flex items-start flex-1">
                <div>
                  <div class="font-semibold">{{ role.roleName }}</div>
                  <div class="text-xs text-gray-500">{{ getRoleDescription(role.roleName) }}</div>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <el-tag 
                  v-if="isUserHasRole(role.roleName)" 
                  type="success" 
                  size="mini"
                >
                  <i class="el-icon-check"></i> Aktif
                </el-tag>
                <el-button 
                  v-if="!isUserHasRole(role.roleName)"
                  size="mini" 
                  type="success" 
                  icon="el-icon-plus"
                  @click="addRoleToUser(role.roleName)"
                  :loading="processingRole === role.roleName"
                >
                  Tambah
                </el-button>
                <el-button 
                  v-else
                  size="mini" 
                  type="danger" 
                  icon="el-icon-delete"
                  @click="removeRoleFromUser(role.roleName)"
                  :loading="processingRole === role.roleName"
                >
                  Hapus
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeManageRoleDialog">Tutup</el-button>
      </div>
    </el-dialog>

    <!-- Reset Password Dialog -->
    <el-dialog
      :visible.sync="resetPasswordDialog"
      width="500px"
      :close-on-click-modal="false"
    >
      <div slot="title" class="bg-gradient-to-r from-orange-600 to-red-600  text-black rounded-t-lg">
        <div class="flex items-center space-x-3">
          <i class="el-icon-key text-2xl"></i>
          <div>
            <h3 class="text-xl font-bold">Reset Password</h3>
            <p class="text-sm text-orange-100">{{ resetPasswordUser.name }} ({{ resetPasswordUser.username }})</p>
          </div>
        </div>
      </div>

      <div class="pt-0 pb-4">
        <div class="bg-yellow-50 p-4 rounded-lg mb-4">
          <div class="flex items-start">
            <i class="el-icon-warning text-yellow-600 text-xl mr-2"></i>
            <div>
              <p class="text-sm text-yellow-800 font-semibold">Peringatan!</p>
              <p class="text-xs text-yellow-700 mt-1">Password akan direset dan user harus menggunakan password baru untuk login.</p>
            </div>
          </div>
        </div>

        <div class="bg-white p-4 rounded-lg border">
          <label class="text-sm font-semibold text-gray-700 block mb-2">Password Baru <span class="text-red-500">*</span></label>
          <el-input
            v-model="newPassword"
            type="password"
            placeholder="Masukkan password baru"
            show-password
            clearable
            @keyup.enter.native="submitResetPassword"
          >
            <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          </el-input>
          <p class="text-xs text-gray-500 mt-2">Minimal 6 karakter</p>
        </div>

        <div class="bg-white p-4 rounded-lg border mt-3">
          <label class="text-sm font-semibold text-gray-700 block mb-2">Konfirmasi Password <span class="text-red-500">*</span></label>
          <el-input
            v-model="confirmPassword"
            type="password"
            placeholder="Konfirmasi password baru"
            show-password
            clearable
            @keyup.enter.native="submitResetPassword"
          >
            <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          </el-input>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeResetPasswordDialog">Batal</el-button>
        <el-button type="warning" @click="submitResetPassword" :loading="submittingPassword" :disabled="!isPasswordValid">
          <i class="el-icon-key"></i> Reset Password
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "UserManagement",
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      items: { selected: [] },
      filters: {
        username: '',
        rolename: ''
      },
      currentPage: 1,
      pageSize: 10,
      userRoleCurrentPage: 1,
      userRolePageSize: 10,
      totalUserRoles: 0,
      totalUserRolePages: 0,
      manageRoleDialog: false,
      selectedUser: {},
      selectedRoles: [],
      submittingRole: false,
      processingRole: null,
      resetPasswordDialog: false,
      resetPasswordUser: {},
      newPassword: '',
      confirmPassword: '',
      submittingPassword: false,
    }
  },
  computed: {
    get_user_role() {
      return this.$store.state.user.user.content;
    },
    get_user_role_pagination() {
      return this.$store.state.user.user;
    },
    get_code() {
      return this.$store.state.user.code;
    },
    get_message() {
      return this.$store.state.user.message;
    },
    get_loading() {
      return this.$store.state.user.loading;
    },
    availableRoles() {
      // Ambil roles dari store dan format untuk options
      const roles = this.$store.state.roles?.roles.data;
      
      // Validasi bahwa roles adalah array
      if (!roles || !Array.isArray(roles)) {
        return [];
      }
      
      // return roles.map(role => ({
      //   value: role.roleName,
      //   label: role.roleName,
      //   icon: this.getRoleIcon(role.roleName),
      //   description: role.description || this.getRoleDescription(role.roleName),
      //   roleName: role.roleName,
      //   menuIds: role.menuIds || []
      // }));

      return roles.map(role => ({
        roleCode: null, description: null, roleName: role.roleName
      }));
    },
    isPasswordValid() {
      return this.newPassword && 
             this.newPassword.length >= 6 && 
             this.newPassword === this.confirmPassword;
    },
  },

  created() {
    // Fetch available roles
    this.$store.dispatch('roles/fetchRoleTrue').catch(error => {
      console.error('Error loading roles:', error);
    });
    
    // Fetch user roles
    this.$store.dispatch('user/fetchUserRole', { 
      page: this.userRoleCurrentPage - 1, 
      size: this.userRolePageSize, 
      search: { 
        username: this.filters.username || '', 
        rolename: this.filters.rolename || '' 
      } 
    });
  },
  methods: {
    handleCheckAllChange(event) {
      // Ketika check all diklik, pilih atau hapus semua item (simpan seluruh data item)
      this.items.selected = event.target.checked ? [...this.get_user_role] : [];
      this.isIndeterminate = false;
    },
    handleCheckChange() {
      // Ketika individual checkbox berubah, update status check all
      const checkedCount = this.items.selected.length;
      this.checkAll = checkedCount === this.get_user_role.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.get_user_role.length;
    },
    handlePageChange(page) {
      this.userRoleCurrentPage = page;
      this.items.selected = [];
      this.checkAll = false;
      this.$store.dispatch('user/fetchUserRole', { 
        page: page - 1, 
        size: this.userRolePageSize,
        search: { 
          username: this.filters.username || '', 
          rolename: this.filters.rolename || '' 
        }
      });
    },
    handleFilterChange() {
      // Reset ke halaman pertama saat filter berubah
      this.userRoleCurrentPage = 1;
      this.items.selected = [];
      this.checkAll = false;
      this.$store.dispatch('user/fetchUserRole', { 
        page: 0, 
        size: this.userRolePageSize,
        search: { 
          username: this.filters.username || '', 
          rolename: this.filters.rolename || '' 
        }
      });
    },
    getRoleTagType(roleName) {
      const typeMap = {
        'ROLE_EMPLOYEE': 'primary',
        'ROLE_OPERATOR': 'warning',
        'ROLE_ADMIN_INFORMATION': 'success',
        'ROLE_ADMIN': 'danger'
      }
      return typeMap[roleName] || ''
    },
    getRoleIcon(roleName) {
      const iconMap = {
        'ROLE_ADMIN': 'el-icon-s-tools',
        'ROLE_OPERATOR': 'el-icon-user',
        'ROLE_ADMIN_INFORMATION': 'el-icon-s-custom',
        'ROLE_EMPLOYEE': 'el-icon-view'
      }
      return iconMap[roleName] || 'el-icon-user'
    },
    getRoleDescription(roleName) {
      const descriptionMap = {
        'ROLE_ADMIN': 'Akses penuh ke semua fitur',
        'ROLE_OPERATOR': 'Akses standar pengguna',
        'ROLE_ADMIN_INFORMATION': 'Akses manajemen tim',
        'ROLE_EMPLOYEE': 'Akses terbatas view only'
      }
      return descriptionMap[roleName] || 'Role pengguna'
    },
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleDateString('id-ID', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    openManageRoleDialog() {
      if (this.items.selected.length === 1) {
        this.selectedUser = { ...this.items.selected[0] };
        // Set current roles sebagai default checked
        this.selectedRoles = this.selectedUser.roles ? this.selectedUser.roles.map(role => role.roleName) : [];
        this.manageRoleDialog = true;
      }
    },
    closeManageRoleDialog() {
      this.manageRoleDialog = false;
      this.processingRole = null;
    },
    openResetPasswordDialog() {
      if (this.items.selected.length === 1) {
        this.resetPasswordUser = { ...this.items.selected[0] };
        this.newPassword = '';
        this.confirmPassword = '';
        this.resetPasswordDialog = true;
      }
    },
    closeResetPasswordDialog() {
      this.resetPasswordDialog = false;
      this.newPassword = '';
      this.confirmPassword = '';
      this.resetPasswordUser = {};
    },
    async submitResetPassword() {
      if (!this.isPasswordValid) {
        this.$message.warning('Password minimal 6 karakter dan harus sama!');
        return;
      }

      if (!this.resetPasswordUser.userId) {
        this.$message.error('User ID tidak ditemukan');
        return;
      }

      try {
        await this.$confirm(
          `Apakah Anda yakin ingin mereset password untuk user ${this.resetPasswordUser.name}?`,
          'Konfirmasi Reset Password',
          {
            confirmButtonText: 'Ya, Reset',
            cancelButtonText: 'Batal',
            type: 'warning'
          }
        );

        this.submittingPassword = true;

        const response = await this.$store.dispatch('user/resetPassword', {
          userId: this.resetPasswordUser.userId,
          newPassword: this.newPassword
        });

        this.$message.success(response.message || 'Password berhasil direset!');
        this.closeResetPasswordDialog();
        this.items.selected = [];
        this.checkAll = false;
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('Gagal reset password: ' + (error.message || 'Unknown error'));
        }
      } finally {
        this.submittingPassword = false;
      }
    },
    isUserHasRole(roleName) {
      return this.selectedUser.roles && this.selectedUser.roles.some(role => role.roleName === roleName);
    },
    async addRoleToUser(roleName) {
      this.processingRole = roleName;
      
      try {
        const response = await this.$store.dispatch('roles/userNeedRole', {
          username: this.selectedUser.userId,
          roleName: roleName
        });
        
        this.$message.success(`Role ${roleName} berhasil ditambahkan!`);
        
        // Update local selectedUser roles immediately
        if (!this.selectedUser.roles) {
          this.selectedUser.roles = [];
        }
        this.selectedUser.roles.push({ roleName: roleName, roleCode: null, description: null });
        
        // Refresh data list to update the main view
        await this.refreshUserList();
        
      } catch (error) {
        this.$message.error('Gagal menambahkan role: ' + (error.message || 'Unknown error'));
      } finally {
        this.processingRole = null;
      }
    },
    async removeRoleFromUser(roleName) {
      this.processingRole = roleName;
      
      try {
        await this.$confirm(`Apakah Anda yakin ingin menghapus role ${roleName} dari user ${this.selectedUser.name}?`, 'Konfirmasi', {
          confirmButtonText: 'Ya, Hapus',
          cancelButtonText: 'Batal',
          type: 'warning'
        });
        
        const response = await this.$store.dispatch('roles/userRemoveRole', {
          username: this.selectedUser.userId,
          roleName: roleName
        });
        
        this.$message.success(`Role ${roleName} berhasil dihapus!`);
        
        // Update local selectedUser roles immediately
        if (this.selectedUser.roles) {
          this.selectedUser.roles = this.selectedUser.roles.filter(role => role.roleName !== roleName);
        }
        
        // Refresh data list to update the main view
        await this.refreshUserList();
        
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('Gagal menghapus role: ' + (error.message || 'Unknown error'));
        }
      } finally {
        this.processingRole = null;
      }
    },
    async refreshUserList() {
      try {
        await this.$store.dispatch('user/fetchUserRole', { 
          page: this.userRoleCurrentPage - 1, 
          size: this.userRolePageSize,
          search: { 
            username: this.filters.username || '', 
            rolename: this.filters.rolename || '' 
          }
        });
        
        // Reset checkbox state
        this.items.selected = [];
        this.checkAll = false;
        
        // Wait for Vue to update the DOM
        await this.$nextTick();
        
        // Update selectedUser dengan data terbaru dari list
        const updatedUser = this.get_user_role.find(user => user.userId === this.selectedUser.userId);
        if (updatedUser) {
          this.selectedUser = { ...updatedUser };
        }
      } catch (error) {
        console.error('Error refreshing user list:', error);
      }
    },
    submitManageRole() {
      if (!this.selectedUser.userId) {
        this.$message.error('User ID tidak ditemukan');
        return;
      }

      if (this.selectedRoles.length === 0) {
        this.$message.warning('Pilih minimal satu role');
        return;
      }

      this.submittingRole = true;

      // console.log(this.selectedUser.username, this.selectedRoles);
      
      for (let index = 0; index < this.selectedRoles.length; index++) {
        const element = this.selectedRoles[index];
        this.$store.dispatch('roles/userNeedRole', {username: this.selectedUser.username, roleName: element})
        .then((response) => {
          this.$message.success(response.message || `Role ${element} berhasil ditambahkan!`);
          this.manageRoleDialog = false;
          this.submittingRole = false;
          this.items.selected = [];
          this.checkAll = false;
          // Refresh data
          this.$store.dispatch('user/fetchUserRole', { 
            page: this.userRoleCurrentPage - 1, 
            size: this.userRolePageSize,
            search: { 
              username: this.filters.username || '', 
              rolename: this.filters.rolename || '' 
            }
          });
        })
        .catch((error) => {
          this.$message.error('Gagal menambahkan role: ' + (error.message || 'Unknown error'));
          this.submittingRole = false;
        });
      }
      // Dispatch action untuk update user role
      // this.$store.dispatch('user/updateUserRole', {
      //   userId: this.selectedUser.userId,
      //   roles: this.selectedRoles,
      //   token: this.getAuthToken()
      // })
      //   .then((response) => {
      //     this.$message.success(response.message || 'Role berhasil diupdate!');
      //     this.manageRoleDialog = false;
      //     this.submittingRole = false;
      //     this.items.selected = [];
      //     this.checkAll = false;
      //     // Refresh data
      //     this.$store.dispatch('user/fetchUserRole', { 
      //       token: this.getAuthToken(), 
      //       page: this.userRoleCurrentPage - 1, 
      //       size: this.userRolePageSize,
      //       search: { 
      //         username: this.filters.username || null, 
      //         rolename: this.filters.rolename || null 
      //       }
      //     });
      //   })
      //   .catch((error) => {
      //     this.$message.error('Gagal update role: ' + (error.message || 'Unknown error'));
      //     this.submittingRole = false;
      //   });
    }
  },
};
</script>
<style scoped>
.list-user-role {
  display: flex;
  flex-direction: column;
  border-bottom: 0.5px solid #ccc;
  padding: 10px 0;
}
.list-user-role-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 0.5px solid #ccc;
  gap: 15px;
}

.filter-section-custom {
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.list-user-role-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0 8px 0;
  /* border-bottom: 0.5px solid #ccc; */
}

.menu-zero {
  margin-right: 15px;
}

.menu-first {
  margin-right: 15px;
}

.menu-second {
  flex-grow: 1;
}

.menu-fourth {
  margin-left: 28px;
}

.menu-fourth, el-tag {
  font-size: 5px;
}

.menu-footer {
  margin: 20px 0 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-name {
  font-weight: bold;
  font-size: 15px;
}

.label-username {
  color: #666;
  font-size: 13px;
}

.label-date {
  color: #666;
  font-size: 12px;
}
</style>